module.exports = __webpack_public_path__ + "img/profile_nophoto.ce3cdff.png";